export const normalizeLeaderPositions = (positions) => {
    if (Array.isArray(positions)) return positions.map(String).map((position) => position.trim()).filter(Boolean);
    if (typeof positions === 'string') {
        const value = positions.trim();
        if (!value) return [];
        if (value.startsWith('[') && value.endsWith(']')) {
            try {
                const parsed = JSON.parse(value);
                if (Array.isArray(parsed)) return parsed.map(String).map((position) => position.trim()).filter(Boolean);
            } catch {
                // Dữ liệu cũ có thể là chuỗi phân cách bằng dấu phẩy.
            }
        }
        return value.split(',').map((position) => position.trim().replace(/^['"]|['"]$/g, '')).filter(Boolean);
    }
    if (positions && typeof positions === 'object') return Object.values(positions).filter((position) => typeof position === 'string').map((position) => position.trim()).filter(Boolean);
    return [];
};

export const getLeaderCategoryIds = (leader) => {
    const values = Array.isArray(leader?.categoryIds) && leader.categoryIds.length
        ? leader.categoryIds
        : Array.isArray(leader?.categories) && leader.categories.length
            ? leader.categories.map((category) => category?.categoryId ?? category?.id)
            : [leader?.categoryId];

    return [...new Set(values.map(Number).filter(Number.isFinite))];
};
